import Lesson from '@/components/lessons/lesson';

import "./lesson.css";

const LessonPage = () => (
  <div className="container-fluid lesson-container">
    <Lesson />
  </div>
);

export default LessonPage;
